import React from 'react';
import './SupportRedesign.css';

const supportSections = [
  {
    id: 'general-questions',
    title: 'General Questions',
    description: 'Here are some of the common questions and answers you might have.',
    items: [
      {
        q: 'Do I have to pay to publish my website?',
        a: 'You can start on the Free plan, and upgrade to Growth, Scale, or Enterprise when you need additional features.',
      },
      {
        q: 'Do I have to buy a domain name to get a website?',
        a: 'No. We can make your website publicly viewable with an EditPage URL.',
      },
      {
        q: 'Can I cancel my subscriptions?',
        a: 'Yes. You can navigate to your account and cancel any active subscription.',
      },
    ],
  },
  {
    id: 'product-support',
    title: 'Product Support',
    description: 'These are typical questions we get about our product.',
    items: [
      {
        q: 'How do I get the editor to show?',
        a: 'Click on any item on your webpage and editor options will appear for that element.',
      },
      {
        q: 'I boosted my traffic but nothing happened.',
        a: 'It can take up to 24 hours for traffic results to be recorded and displayed.',
      },
      {
        q: 'How many websites can I have?',
        a: 'You can create as many websites as you need. We do not limit pages per domain.',
      },
    ],
  },
  {
    id: 'email-support',
    title: 'Email Support',
    description: 'Basic email questions to help you along.',
    items: [
      {
        q: 'How do I know if my email sent?',
        a: 'Send a test message to another address you control to verify delivery.',
      },
      {
        q: 'Do you support IMAP and other client access?',
        a: 'Right now, we support our built-in email client only.',
      },
      {
        q: 'How secure is the email system?',
        a: 'Our email system follows common modern security standards for hosted messaging.',
      },
    ],
  },
  {
    id: 'domain-support',
    title: 'Domain Name Support',
    description: 'Questions about your domain name on EditPage.',
    items: [
      {
        q: 'Will I be able to transfer my domain name?',
        a: 'At this time, domains purchased here are designed to stay managed on our platform.',
      },
      {
        q: 'Do you really offer some domain names for free?',
        a: 'Yes. Select website packages include a free first-year domain purchase.',
      },
      {
        q: 'Do you support most common TLDs?',
        a: 'Yes. Most popular TLDs are available through our domain search flow.',
      },
    ],
  },
  {
    id: 'traffic-support',
    title: 'Boost Traffic Support',
    description: 'How our traffic system works and common questions.',
    items: [
      {
        q: 'If I purchase more traffic, will I get more customers?',
        a: 'Not always. Traffic can improve visibility, but conversion depends on offer, messaging, and audience fit.',
      },
      {
        q: 'How quickly does traffic boosting start?',
        a: 'Most campaigns begin quickly, and reporting usually reflects data within 24 hours.',
      },
      {
        q: 'Can I pause a traffic campaign?',
        a: 'Yes. You can pause active campaigns in your account dashboard settings.',
      },
    ],
  },
];

const quickLinks = [
  { id: 'general-questions', label: 'General Questions' },
  { id: 'product-support', label: 'Product Support' },
  { id: 'email-support', label: 'Email Support' },
  { id: 'domain-support', label: 'Domain Support' },
  { id: 'traffic-support', label: 'Boost Traffic Support' },
  { id: 'contact', label: 'Contact Us' },
];

const SupportContent = ({ history, classes, Accordion, AccordionSummary, ExpandMoreIcon, AccordionDetails, Typography }) => {
  return (
    <div className="support-redesign">
      <section className="support-hero">
        <div className="support-wrap">
          <p className="support-eyebrow">Support center</p>
          <h1>Support</h1>
          <p>EditPage is here to help. Just let us know.</p>
          <button
            type="button"
            onClick={() => {
              history.push('/signup');
            }}
          >
            Start Building
          </button>

          <div className="support-quick-links">
            {quickLinks.map(link => (
              <a key={link.id} href={`#${link.id}`}>{link.label}</a>
            ))}
          </div>
        </div>
      </section>

      <section className="support-faq">
        <div className="support-wrap">
          {supportSections.map(section => (
            <article className="support-card" id={section.id} key={section.id}>
              <h2>{section.title}</h2>
              <p className="support-card-sub">{section.description}</p>
              <div className="support-accordion-list">
                {section.items.map((item, index) => (
                  <Accordion className="support-accordion" key={`${section.id}-${index}`}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`${section.id}-panel-${index}`}
                      id={`${section.id}-header-${index}`}
                    >
                      <Typography className={classes.heading}>{item.q}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.heading}>{item.a}</Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            </article>
          ))}

          <article className="support-contact" id="contact">
            <h2>Need direct help?</h2>
            <p>Contact our team and we will help you with account, billing, or technical issues.</p>
            <a href="/contact">Go to Contact Us -&gt;</a>
          </article>
        </div>
      </section>
    </div>
  );
};

export default SupportContent;
